/**
 * Encode each path segment of a media URL so S3/CloudFront keys that contain
 * literal percent-sequences (e.g. Capture%20d%E2%80%99%C3%A9cran….png) are
 * requested as stored.
 *
 * Do not use the URL constructor for the path: it decodes %XX first, which
 * would turn a stored key of "Capture%20…" back into "Capture …" and undo
 * the fix. Skip segments that already contain %25 to avoid triple-encoding.
 */
export function encodeMediaUrl(url: string | null | undefined): string {
  if (!url) return "";

  const match = url.match(/^(https?:\/\/[^/]+)(\/[^?#]*)(.*)$/i);
  if (!match) return url;

  const [, origin, path, rest] = match;
  const encodedPath = path
    .split("/")
    .map((segment) => {
      if (!segment) return segment;
      if (/%25/i.test(segment)) return segment;
      return encodeURIComponent(segment);
    })
    .join("/");

  return `${origin}${encodedPath}${rest}`;
}

export function encodeMediaUrlsInHtml(html: string | null | undefined): string {
  if (!html) return "";

  return html.replace(/\b(src|href)=(["'])(https?:\/\/[^"']+)\2/gi, (_match, attr: string, quote: string, url: string) => {
    return `${attr}=${quote}${encodeMediaUrl(url)}${quote}`;
  });
}
